import { Injectable } from '@angular/core';
import { ImageFile } from '../models/imageFile';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GalleryHistoryService {
  private historyCollection: ImageFile[] = [];
  private historyCollection$: BehaviorSubject<ImageFile[]> = new BehaviorSubject<ImageFile[]>([]);
  private historyMaxLength = 5;

  constructor() { }

  public addImageToHistory(img: ImageFile): void {
    const exists = this.historyCollection.map(i => i.uid).indexOf(img.uid);
    if (exists > -1) {
      // console.debug(`image already in history (${exists}). Moving to end`);
      this.historyCollection.push(this.historyCollection.splice(exists, 1)[0]); // move the existing recent image to the end.
    } else {
      this.historyCollection.push(img);
    }
    // this.historyCollection = this.historyCollection.filter((v, i, a) => a.findIndex(t => (t.uid === v.uid)) === i);
    // console.debug(this.historyCollection.map(i => i.uid));
    // console.debug('image added to history: ', img.uid);
    if (this.historyCollection.length > this.historyMaxLength) {
      this.historyCollection.shift();
      // eslint-disable-next-line no-console
      console.info('truncating history');
    }
    this.historyCollection$.next(this.historyCollection);
  }

  public imageHistory(): Observable<ImageFile[]> {
    return this.historyCollection$.asObservable();
  }
  public getImageHistory(): void {
    this.historyCollection$.next(this.historyCollection);
  }

  public clearImageHistory(): void {
    this.historyCollection = [];
    this.historyCollection$.next([]);
  }

  // TODO: Call clearHistory on logout
}
